import React from "react";
import { HeartHandshake, BadgeCheck, LifeBuoy } from "lucide-react";
import { whyChoose } from "../mock";
import useReveal from "../hooks/useReveal";

const icons = { HeartHandshake, BadgeCheck, LifeBuoy };

export default function WhyChooseUs() {
  const ref = useReveal();
  return (
    <section id="why" ref={ref} className="bg-white py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto px-5">
        <div className="text-center mb-14 cc-reveal">
          <h2 className="font-head text-3xl md:text-4xl font-bold text-[#16244F]">Why Choose Us</h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded-full bg-[#F58220]" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {whyChoose.map((w, i) => {
            const Icon = icons[w.icon];
            return (
              <div
                key={w.title}
                className="cc-reveal text-center p-8 rounded-2xl border border-gray-100 hover:border-[#2b8cf0]/40 hover:shadow-[0_18px_50px_-24px_rgba(22,36,79,0.35)] transition-all duration-300 group"
                style={{ animationDelay: `${i * 0.12}s` }}
              >
                <div className="mx-auto w-20 h-20 rounded-2xl bg-[#eaf3ff] text-[#2b8cf0] flex items-center justify-center mb-6 transition-colors duration-300 group-hover:bg-[#2b8cf0] group-hover:text-white">
                  <Icon size={38} strokeWidth={1.7} />
                </div>
                <h3 className="font-head text-xl font-semibold text-[#16244F] mb-3">{w.title}</h3>
                <p className="text-[15px] leading-relaxed text-[#5a6274]">{w.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
